import { consts } from '../actions/ToolkitActions';

const initialState = {
  fetched: false,
  fetching: false,
  error: null,
  createdProjectFetched: false,
  createdProjectFetching: false,
  createdProjectData: {},
  projectsList: {},
  deleteData: {},
  dublicateData: {},
  validationFetching: false,
  validationData: {},
  messageFetched: false,
  messageFetching: false,
  messageError: null,
  messageSuccess: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case consts.CREATE_PROJECT_PENDING: {
      state = Object.assign({}, state, { createdProjectFetching: true, createdProjectFetched: false });
      break;
    }
    case consts.CREATE_PROJECT_FULFILLED: {
      state = Object.assign({}, state, {createdProjectFetched: true, createdProjectFetching: false, createdProjectData: action.data });
      break;
    }
    case consts.CREATE_PROJECT_REJECTED: {
      state = Object.assign({}, state, {createdProjectFetched: false, createdProjectFetching: false, error: action.error});
      break;
    }

    case consts.RESET_CREATE_PROJECT: {
      state = Object.assign({}, state, {createdProjectFetched: true, createdProjectFetching: false, createdProjectData: {} });
      break;
    }

    case consts.RESET_DELETE_PROJECT: {
      state = Object.assign({}, state, {createdProjectFetched: true, createdProjectFetching: false, deleteData: {} });
      break;
    }

    case consts.GET_PROJECTS_LIST_PENDING: {
      state = Object.assign({}, state, { fetching: true });
      break;
    }
    case consts.GET_PROJECTS_LIST_FULFILLED: {
      state = Object.assign({}, state, { fetching: false, projectsList: action.data });
      break;
    }
    case consts.GET_PROJECTS_LIST_REJECTED: {
      state = Object.assign({}, state, { fetching: false, error: action.error });
      break;
    }
    case consts.TOOLKIT_VALIDATION_PENDING: {
      state = Object.assign({}, state, { validationFetching: true });
      break;
    }
    case consts.TOOLKIT_VALIDATION_FULFILLED: {
      state = Object.assign({}, state, { validationFetching: false, validationData: action.data });
      break;
    }
    case consts.TOOLKIT_VALIDATION_REJECTED: {
      state = Object.assign({}, state, { validationFetching: false, error: action.error });
      break;
    }

    case consts.RESET_TOOLKIT_VALIDATION: {
      state = Object.assign({}, state, { validationFetching: false, validationData: {} });
      break;
    }

    case consts.DELETE_PROJECT_PENDING: {
      state = Object.assign({}, state, { fetching: true });
      break;
    }
    case consts.DELETE_PROJECT_FULFILLED: {
      state = Object.assign({}, state, { fetching: false, deleteData: action.data });
      break;
    }
    case consts.DELETE_PROJECT_REJECT: {
      state = Object.assign({}, state, { fetching: false, error: action.error });
      break;
    }
    case consts.DUBLICATE_PROJECT_PENDING: {
      state = Object.assign({}, state, { fetching: true });
      break;
    }
    case consts.DUBLICATE_PROJECT_FULFILLED: {
      state = Object.assign({}, state, {fetching: false, dublicateData: action.data });
      break;
    }
    case consts.DUBLICATE_PROJECT_REJECTED: {
      state = Object.assign({}, state, {fetching: false, error: action.error});
      break;
    }
    case consts.SEND_MESSAGE_PENDING: {
      state = Object.assign({}, state, { messageFetching: true });
      break;
    }
    case consts.SEND_MESSAGE_FULFILLED: {
      state = Object.assign({}, state, {messageFetching: false, messageSuccess: action.data });
      break;
    }
    case consts.SEND_MESSAGE_REJECTED: {
      state = Object.assign({}, state, {messageFetching: false, messageError: action.error});
      break;
    }
  }
  return state;
}





// WEBPACK FOOTER //
// ./src/store/reducers/ToolkitReducer.js